import { render, staticRenderFns } from "./housekeepingServPoolManage.vue?vue&type=template&id=cb8e1b24&scoped=true"
import script from "./housekeepingServPoolManage.vue?vue&type=script&lang=js"
export * from "./housekeepingServPoolManage.vue?vue&type=script&lang=js"
import style0 from "./housekeepingServPoolManage.vue?vue&type=style&index=0&id=cb8e1b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8e1b24",
  null
  
)

export default component.exports